//import { Params } from '@angular/router';

import { Policy } from '@summit/core';
import { SideBarDef } from 'ag-grid-enterprise';

import { DisplaySchema } from '../display-schema';
import { DisplayType } from '../display-type.enum';
import { FilterParameter } from '../filter-parameter';
import { SortAttribute } from '../sort-attribute';
import { SummitIdObject } from '../summit-id-object';
import { ViewType } from './view-info';

export type DateBarTypes =
  | 'none'
  | 'weekRange'
  | 'weekRangeWithNum'
  | 'month'
  | 'day'
  | 'dateRange'
  | 'monthRange'
  | 'week';

export class ViewConfig<T> extends SummitIdObject {
  // static refServerObjectName = 'Hub'
  static refServerAPI = 'ViewConfigs';

  override id: string;
  name: string;
  policy?: Policy;
  type: ViewType;
  tableName?: string;
  dateBar?: DateBarTypes;
  dateBarLabel?: string;
  viewColumns: (keyof T & string)[];
  columnOrder?: (keyof T & string)[];
  groupBy?: (keyof T & string)[];
  /* Need to rework since we aren't mapping to groups anymore*/
  //Number of Group By columns to shift to columns when screen is large
  groupByShiftToColumns?: number;
  groupShiftToColumnsAfter?: number;

  pinnedColumns?: (keyof T & string)[];
  viewBy?: (keyof T & string)[]; //AG-Grid work pending - not sure the point

  //pivot
  pivotColumns?: (keyof T & string)[];

  //filter
  filterString?: string; //AG-Grid work pending
  filterColumns?: (keyof T & string)[]; //AG-Grid work pending
  filterParameters?: Array<Partial<FilterParameter>>; //AG-Grid work pending
  sortParameters?: SortAttribute<T> | SortAttribute<T>[];
  showNewButton?: boolean;
  showFooter?: boolean; //AG-Grid work pending
  showGroupFooters?: boolean;
  public showGroupFooterOfOne?: (singleEntry: T | undefined) => boolean;
  //Leave blank for all group rows or list inclusive list of group rows with footers
  groupFooterRows?: (keyof T & string)[];
  urlAsView?: boolean; //AG-Grid work pending
  //AG Grid work
  dragEnabled?: (keyof T & string)[];
  selectable?: 'single' | 'multiple';
  rowMultiSelectWithClick?: boolean;
  public lockColumns?: boolean;
  public suppressColumnMenus?: boolean;
  public sideBar?: string[] | SideBarDef;

  constructor(jsonData?: Partial<ViewConfig<T>>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.viewColumns) {
        this.viewColumns = jsonData.viewColumns.map((data) => data);
      } else {
        this.viewColumns = new Array<keyof T & string>();
      }
      this.pinnedColumns = jsonData.pinnedColumns?.map((data) => data) ?? [];
      if (jsonData.columnOrder) {
        this.columnOrder = jsonData.columnOrder.map((data) => data);
      } else if (jsonData.viewColumns) {
        this.columnOrder = jsonData.viewColumns.map((data) => data);
      } else {
        this.columnOrder = new Array<keyof T & string>();
      }
      if (jsonData.filterColumns) {
        this.filterColumns = jsonData.filterColumns.map((data) => data);
      } else {
        this.filterColumns = new Array<keyof T & string>();
      }
      if (jsonData.filterParameters) {
        this.filterParameters = Array.isArray(jsonData.filterParameters)
          ? jsonData.filterParameters.map((data) => new FilterParameter(data))
          : Object.keys(jsonData.filterParameters).map(
              (key) => new FilterParameter({ id: key, state: (jsonData.filterParameters as any)[key] === 'true' })
            );
      }
      if (jsonData.sortParameters) {
        this.sortParameters = Object.assign({}, jsonData.sortParameters);
      }
      if (jsonData.dragEnabled) this.dragEnabled = jsonData.dragEnabled.map((data) => data);
    }
    this.filterParameters ??= new Array<Partial<FilterParameter>>();
    this.policy ??= Policy.Any;
    this.type ??= ViewType.Custom;
    this.rowMultiSelectWithClick ??= false;
    this.showNewButton ??= true;
    this.showFooter ??= false;
    this.showGroupFooters ??= false;
    this.lockColumns ??= false;
    this.suppressColumnMenus ??= false;
    this.urlAsView ??= false;
    //console.log(`Created View Config ${this.id} .. from ..`, this, jsonData);
    //To avoid affecting all the schemas
    Object.defineProperty(this, 'viewColumnsNot', {
      get() {
        if (!this.relatedSchema) return [];
        return (
          Object.keys(this.relatedSchema.refColumnList).filter(
            (key) =>
              !this.viewColumns.includes(key as keyof T & string) &&
              this.relatedSchema.refColumnList[key as keyof T & string].columnField &&
              this.displayType !== DisplayType.Hidden
          ) as (keyof T & string)[]
        ).sort(
          (a, b) =>
            this.relatedSchema.refColumnList[a].displayName?.localeCompare(
              this.relatedSchema.refColumnList[b].displayName
            ) ?? 1
        );
      },
      set(_) {
        //NOP
      }
    });
    Object.defineProperty(this, 'filterColumnsNot', {
      get() {
        if (!this.relatedSchema) return [];
        return (
          Object.keys(this.relatedSchema.refColumnList).filter(
            (key) =>
              !this.filterColumns.includes(key as keyof T & string) &&
              this.relatedSchema.refColumnList[key as keyof T & string].columnField &&
              this.displayType !== DisplayType.Hidden
          ) as (keyof T & string)[]
        ).sort(
          (a, b) =>
            this.relatedSchema.refColumnList[a].displayName?.localeCompare(
              this.relatedSchema.refColumnList[b].displayName
            ) ?? 1
        );
      },
      set(_) {
        //NOP
      }
    });
  }

  relatedSchema?: DisplaySchema<SummitIdObject>;
}
